import React from "react";
import { useNavigate } from "react-router-dom";
import { ClipboardList, Users, Pencil, Plus } from "lucide-react";
import { useAuth } from "../../auth/AuthContext";
import "./Dashboard.scss";

function rotuloTipo(tipo) {
  const t = String(tipo || "").toLowerCase();
  if (t === "secundario") return "Secundária";
  if (t === "primario") return "Primária";
  return "—";
}

export default function Dashboard() {
  const navigate = useNavigate();
  const { usuario } = useAuth();
  const tipo = String(usuario?.tipo || "").toLowerCase();
  const turmas = Array.isArray(usuario?.turmas) ? usuario.turmas : [];
  const podeCriarTurma = tipo === "coordenador";

  return (
    <div className="dashboard">
      <header className="dashboard__header">
        <div>
          <h1>Suas turmas</h1>
          <p>
            {turmas.length}{" "}
            {turmas.length === 1 ? "turma vinculada" : "turmas vinculadas"}
          </p>
        </div>
        {podeCriarTurma && (
          <button
            type="button"
            className="dashboard__cta"
            onClick={() => navigate("/nova-turma")}
          >
            <Plus size={18} /> Nova turma
          </button>
        )}
      </header>

      <div className="dashboard__grid">
        {turmas.map((t) => (
          <article key={t.id} className="dashboard__card">
            <div className="dashboard__card-head">
              <h2>{t.nome}</h2>
              <span
                className={`dashboard__tag dashboard__tag--${String(t.tipo || "").toLowerCase()}`}
              >
                {rotuloTipo(t.tipo)}
              </span>
            </div>
            {t.complemento && <p className="dashboard__sub">{t.complemento}</p>}

            <div className="dashboard__actions">
              <button
                type="button"
                onClick={() => navigate(`/turma/${t.id}/alunos`)}
              >
                <Users size={16} /> Alunos
              </button>
              <button
                type="button"
                onClick={() => navigate(`/eventos?turmaId=${t.id}`)}
              >
                <ClipboardList size={16} /> Eventos
              </button>
              <button
                type="button"
                onClick={() => navigate(`/editar-turma/${t.id}`)}
              >
                <Pencil size={16} /> Editar
              </button>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
